import t from "./help-center-articles-search8.js";
import e from "./help-center-articles-search26.js";
import { initReactI18next as n } from "./help-center-articles-search27.js";
t.use(n).init({
  resources: e,
  lng: "en_us",
  fallbackLng: "en_us",
  ns: "vistaprint",
  defaultNS: "vistaprint",
  interpolation: {
    escapeValue: !1
  }
});
export {
  t as default
};
//# sourceMappingURL=help-center-articles-search7.js.map
